import { __ } from '@wordpress/i18n';
import { usePitchField } from './context.js';

const STATES = [
	{ state: 'free',     label: () => __( 'Available', 'web-sponsors-pitch' ) },
	{ state: 'selected', label: () => __( 'Selected by you', 'web-sponsors-pitch' ) },
	{ state: 'pending',  label: () => __( 'Reservation pending', 'web-sponsors-pitch' ) },
	{ state: 'occupied', label: () => __( 'Occupied', 'web-sponsors-pitch' ) },
];

/**
 * Visual legend explaining tile state colours.
 * Shows the conflict entry only when there are active conflicts.
 *
 * Zustand selector returns a boolean — re-renders only when conflict status flips.
 */
export default function Legend() {
	const { mode } = usePitchField();

	const filtered = mode === 'preview'
		? STATES.filter( ( s ) => s.state !== 'selected' )
		: STATES;

	return (
		<ul className="wsp-legend" aria-label={__( 'Legend', 'web-sponsors-pitch' )}>
			{filtered.map( ( { state, label } ) => (
				<li key={state} className={`wsp-legend__item wsp-legend__item--${ state }`}>
					<span className="wsp-legend__swatch" aria-hidden="true" />
					<span className="wsp-legend__label">{label()}</span>
				</li>
			) )}
		</ul>
	);
}
